import { render, staticRenderFns } from "./buyCardOrder.vue?vue&type=template&id=10b08fc4&scoped=true&"
import script from "./buyCardOrder.vue?vue&type=script&lang=js&"
export * from "./buyCardOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b08fc4",
  null
  
)

export default component.exports